import { useMemo } from "react";
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";
import VisibilityIcon from "@mui/icons-material/Visibility";

export const useGetColumns = (delegaciones, getChipEstado, setOpenDialog, setIdProfesional, setIdProfesionalMonitoreoSelected) => {

    const handleClickView = (row) => {
        setOpenDialog(true);
        setIdProfesional(row.idProfesional);
        setIdProfesionalMonitoreoSelected(row.idProfesionalMonitoreo);
    };

    const initialColumns = [
        {
            headerName: "",
            field: "action",
            flex: 1,
            sortable: false,
            renderCell: (cellProps) => {
                const { row } = cellProps;
                return (
                    <div
                        onClick={() => handleClickView(row)}
                        className="item-option clickable-option"
                        style={{ paddingTop: '7px' }}
                        aria-hidden='true'
                    >
                        <VisibilityIcon className="edit-icon" />
                    </div>
                );
            },
        },
        {
            flex: 2,
            field: "idSugerenciaMonitoreo",
            headerName: "ID",
        },
        {
            flex: 13,
            field: "idProfesional",
            headerName: "Id Profesional",
        },
        {
            flex: 15,
            field: "nombreProfesional",
            headerName: "Profesional",
        },
        {
            flex: 11,
            field: "claseActual",
            headerName: "Clase actual",
        },
        {
            flex: 11,
            field: "claseSugerida",
            headerName: "Clase sugerida",
        },
        {
            flex: 12,
            field: "resultadoUltimoMonitoreo",
            headerName: "Res. último monitoreo",
        },
        {
            flex: 15,
            field: "fechaSolicitud",
            headerName: "F. solicitud",
            type: "date"
        },
        {
            flex: 12,
            field: "idEstado",
            headerName: "Estado",
            renderCell: ({ row }) => {
                return getChipEstado(row.idEstado);
            }
        },
        {
            flex: 15,
            field: "solicitante",
            headerName: "Solicitante",
        },
        {
            flex: 10,
            field: "fechaResolucion",
            headerName: "F. Resolución",
            type: "date",
            limitDate: 1000
        },
        {
            flex: 15,
            field: "observacionUsuarioSolicitante",
            headerName: "Observación Solicitante",
            type: "string"
        },
        {
            flex: 15,
            field: "autorizador",
            headerName: "Autorizador",
        },
    ];

    const columns = useMemo(
        () => generateColumnsDefaultConfiguration(initialColumns, true),
        [delegaciones, getChipEstado]
    );

    return columns;
}